import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import ShipmentStatus from '../ShipmentStatus';
import HandlingListFormatter from './HandlingListFormatter';
import MethodFormatter from './MethodFormatter';
import ContactFormatter from '@afosto/utils-react/formatters/ContactFormatter';
import ShipmentsFormatter from '@afosto/utils-react/formatters/ShipmentsFormatter';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const ORDERS_APP_ORIGIN = BASE_URL.replace('{app}', 'orders');

export const shipmentFormatter = (cell, row) => (
  <MuiLink variant="subtitle1" component={Link} to={`/shipments/${row.id}`}>
    {(row.number && row.number?.toUpperCase()) || row.id}
  </MuiLink>
);

export const shipmentsFormatter = cell => <ShipmentsFormatter shipmentIds={cell} />;

export const contactFormatter = cell => <ContactFormatter contactId={cell} />;

export const methodFormatter = cell => <MethodFormatter methodId={cell} />;

export const handlingListFormatter = cell => <HandlingListFormatter handlingListId={cell} />;

export const statusFormatter = (cell, row) => <ShipmentStatus shipment={row} />;

export const orderFormatter = (cell, row) => {
  const isSameOrigin = window.location.origin === ORDERS_APP_ORIGIN;

  if (!row.order_id && !row.order_number) {
    return '-';
  }

  if (!row.order_id && row.order_number) {
    return row.order_number?.toUpperCase() || '-';
  }

  if (isSameOrigin) {
    return (
      <MuiLink variant="subtitle1" component={Link} to={`/orders/${row.order_id}`}>
        {row?.order_number?.toUpperCase() || '-'}
      </MuiLink>
    );
  }

  return (
    <MuiLink variant="subtitle1" href={`${ORDERS_APP_ORIGIN}/orders/${row.order_id}`}>
      {row?.order_number?.toUpperCase() || '-'}
    </MuiLink>
  );
};

export default shipmentFormatter;
